import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useIntl, useSelector, useDispatch, getLocale, useLocation, history } from 'umi';
import { AutoComplete, SearchBox, useOutsideClick } from "tea-component";
import { MetricsItemType } from '@/pages/dashboard/types/dashboard';
import './index.scss';
import { getPathFromDashboard, getMetricsDashboard, parseUrlInfo } from "@/pages/dashboard/utils/utils";
import Splitter from './Splitter';

// 获取目录名称, 如果中文名称不存在, 则获取英文名称
export const getFieldName = (local: string, data: any) => local === 'zh-CN' && data?.name_cn || data?.name_en;

// 获取目录名称, 如果中文名称不存在, 则获取英文名称
export const getParentFieldName = (local: string, data: any) => local === 'zh-CN' && data?.parent_name_cn || data?.parent_name_en;

const SearchPage = () => {
  const [inputValue, setInputValue] = useState<string>(''); // 搜索输入框值
  const [open, setOpen] = useState<boolean>(false); // 下拉框显示
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const local = getLocale();
  // 搜索框添加拖拽拉宽拉长
  const [searchBoxStyle,setSearchBoxStyle] = useState({});
  const searchRef = useRef(null);
  const { listen } = useOutsideClick(searchRef);
  listen(() => setOpen(false));

  const { urlId: urlGameCode } = parseUrlInfo(location.pathname);

  const { currentGame, metricsList, customizedMetricsList, dashboardList } = useSelector(state => {
    // @ts-ignore
    const { currentGame, metricsList, customizedMetricsList, dashboardList } = state.dashboard;
    return {
      dashboardList,
      currentGame,
      metricsList,
      customizedMetricsList,
    };
  });

  // 获取指标
  useEffect(() => {
    dispatch({
      type: "dashboard/getMetricsList",
      payload: {
        language: local === 'zh-CN' ? "_zh" : ""
      }
    });
  }, [local]);

  // 获取特性指标
  useEffect(() => {
    if (!currentGame || urlGameCode !== currentGame.game_code) {
      return;
    }
    dispatch({
      type: "dashboard/getCustomizedMetricsList",
      payload: {
        gameCode: currentGame.game_code
      }
    });
    setInputValue('');
  }, [currentGame, urlGameCode]);

  // 筛选处理
  const filterOption = useMemo(() => {
    const val = inputValue?.toLowerCase();

    // 报表搜索，支持匹配报表名称或匹配菜单名称下的所有报表
    // 报表搜索，支持匹配报表名称或匹配菜单名称下的所有报表
    const filterPages = (dashboardList || []).filter((item: any) => (getFieldName(local, item)?.toLowerCase()?.includes(val) || getParentFieldName(local, item)?.toLowerCase()?.includes(val))).map((item: any) => ({
      groupKey: 'page',
      value: item.id,
      text: `${getParentFieldName(local, item)  }/${  getFieldName(local, item)}`,
      item
    }));

    // 通用指标搜索
    const filterMetricsList = (metricsList || []).filter((item: MetricsItemType) => item.key?.toLowerCase()?.includes(val)).map((item: MetricsItemType) => ({
      groupKey: 'metrics',
      value: item.key,
      text: item.key,
      item
    }));

    // 特性指标搜索
    const filterCustomMetricsList = (customizedMetricsList || []).filter((item: MetricsItemType) => item.key?.toLowerCase()?.includes(val)).map((item: MetricsItemType) => ({
      groupKey: 'customMetrics',
      value: item.key,
      text: item.key,
      item
    }));
    return {
      options: [...filterPages, ...filterMetricsList, ...filterCustomMetricsList],
      groups: {
        page: formatMessage({id: 'common_pages'}),
        metrics: formatMessage({id: 'common_metrics'}),
        customMetrics: formatMessage({id: 'common_customized_metrics'})
      }
    };
  }, [metricsList, customizedMetricsList, dashboardList, inputValue, local]);

  // 点击搜索结果
  const handleClickItem = (value: string) => {
    const option = filterOption.options.find(opt => opt.value === value);
    if (option) {
      // 搜索目录的情况
      if (option.groupKey === 'page') {
        const path = getPathFromDashboard(option.item);
        // dispatch({
        //   type:"dashboard/save",
        //   payload: {
        //     currentMenu: option.item
        //   }
        // });
        history.push(`/dashboard/game/${currentGame.game_code}/${path}`);
      } else {
        const { item } = option;
        if (!item?.value) {
          return;
        }

        if (item.value.startsWith('?')) {
          const dashboard = getMetricsDashboard(dashboardList, item.value);
          if (dashboard) {
            const path = getPathFromDashboard(dashboard);
            history.push(`/dashboard/game/${currentGame.game_code}/${path}`);
            // 特性报表的跳转, 不需要对New表示进行处理
          }
        } else {
          const path = item.value.startsWith?.('/') ? item.value : `/${item.value}`;
          history.push(`/dashboard/game/${currentGame.game_code}${path}`);
        }
      }
    }
    setOpen(false);
  };

  return (
    <div className='navmenu-hd-search' ref={searchRef} >
      <AutoComplete
        className="dtd-db-search-page"
        overlayClassName="dtd-db-search-page-wrap"
        style={searchBoxStyle}
        open={!!inputValue && open}
        // onOpenChange={val => { setOpen(val) }}
        options={filterOption.options}
        groups={filterOption.groups}
        keyword={inputValue}
        tips={formatMessage({id: 'common_no_report_serach'})}
        onChange={handleClickItem}
        popupContainer={document.querySelector('.navmenu-hd-search')}
      // onScrollBottom={event => console.log(event)}
      >
        {ref => (
          <SearchBox
            ref={ref}
            className='navmenu-hd-search-input'
            value={inputValue}
            // onSearch={console.log}
            onChange={value=>{
              setInputValue(value);
              setOpen(true);
            }}
            // onClear={() => console.log("clear")}
            // onHelp={() => console.log("help")}
            placeholder={formatMessage({id: 'game_selector_no_Search_metrics'})}
          />
        )}
      </AutoComplete>
      {(!!inputValue && open)&&<Splitter setSearchBoxStyle={setSearchBoxStyle} inputValue={inputValue}/>}
    </div>
  );
};

export default SearchPage;
